import sharedPropsService from "../../SharedPropsService";
import { ROUTE } from "../../routes";
import { triggerAmplitudeEventCGS } from "../cgtcInit/utils";
export const goBackAction = async (action, _datastore, { navigate }) => {
    const fromRouteId = action?.payload?.routeId;
};
export const editDetailsAction = async (action, _datastore, { navigateToBase, instrumentTrack }) => {
    console.warn('*** editDetailsAction ***');
    await triggerAmplitudeEventCGS(instrumentTrack, {
        eventName: 'CGS_EDIT_BUTTON_CLICKED'
    });
    const userContext = await sharedPropsService.getCgtcUserContext();
    await sharedPropsService.setCgtcUserContext({
        pan: userContext?.pan,
        phone: userContext?.phone,
        fromDate: userContext?.fromDate,
        toDate: userContext?.toDate
    });
    await sharedPropsService.setToken(undefined);
    await navigateToBase(ROUTE.CGTC_INIT);
};
export const onDownLoadEarningReport = async (action, _datastore, { instrumentTrack }) => {
    const downloadURL = action?.payload?.downloadURL;
    const extension = 'xls';
    const cgstUserContext = await sharedPropsService.getCgtcUserContext();
    fetch(downloadURL)
        .then((response) => response.blob())
        .then((blob) => {
        // Create a temporary anchor element to initiate the download
        const url = window.URL.createObjectURL(new Blob([blob]));
        const a = document.createElement('a');
        a.href = url;
        a.download = `${cgstUserContext?.pan}_${cgstUserContext?.fromDate}_${cgstUserContext?.toDate}.${extension}`;
        document.body.appendChild(a);
        a.click();
        URL.revokeObjectURL(url);
        document.body.removeChild(a);
        triggerAmplitudeEventCGS(instrumentTrack, {
            eventName: 'CGS_DOWNLOAD_CTA_CLICKED'
        });
    })
        .catch((error) => {
        console.warn('Error download file: ', error);
    });
};
export const toolTipAmplitudeEventAction = async (action, _datastore, { instrumentTrack }) => {
    console.warn('*** toolTipAmplitudeEventAction ***', action);
    const tooltip_num = action?.payload?.tooltip_num;
    await triggerAmplitudeEventCGS(instrumentTrack, {
        eventName: 'CGS_TOOLTIP_CLICKS',
        tooltip_num: tooltip_num
    });
};
